import { Skeleton } from '@/shared/ui/atoms';

/**
 * Skeleton de carregamento para a tela de preview de avaliação.
 *
 * Espelha a estrutura visual do ExamPreviewTemplate para evitar layout shift
 * ao carregar os dados iniciais (exam + questions list).
 */
export function ExamPreviewSkeleton() {
  return (
    <div className="flex flex-col gap-sm">
      {/* Breadcrumb */}
      <div className="flex items-center gap-nano">
        <Skeleton className="h-micro w-micro" />
        <Skeleton className="h-quark w-quark" />
        <Skeleton className="h-micro w-xxs" />
        <Skeleton className="h-quark w-quark" />
        <Skeleton className="h-micro w-xs" />
      </div>

      {/* Page Title */}
      <div className="flex flex-col gap-quark">
        <Skeleton className="h-xs w-1/3" />
        <Skeleton className="h-mini w-1/5" />
      </div>

      {/* Question Card */}
      <div className="overflow-hidden rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface shadow-level1">
        {/* Card Header */}
        <div className="flex items-center gap-nano border-b-hairline border-ctx-layout-border bg-ctx-layout-spotlight px-xs py-micro">
          <Skeleton shape="circle" className="h-mini w-mini shrink-0" />
          <Skeleton className="h-mini w-1/6" />
          <Skeleton className="h-micro w-[52px]" />
        </div>

        {/* Language Tabs */}
        <div className="flex items-center gap-xs border-b-hairline border-ctx-layout-border px-xs py-quark">
          <Skeleton className="h-mini w-xxs" />
          <Skeleton className="h-mini w-mini" />
          <Skeleton className="h-mini w-xxs" />
        </div>

        {/* Question Body */}
        <div className="flex flex-col gap-mini p-xs">
          {/* Statement skeleton */}
          <div className="flex flex-col gap-nano">
            <Skeleton className="h-mini w-1/6" />
            <div className="flex flex-col gap-quark rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-body p-micro">
              <Skeleton className="h-mini w-full" />
              <Skeleton className="h-mini w-full" />
              <Skeleton className="h-mini w-3/4" />
            </div>
          </div>

          {/* Alternatives skeleton */}
          <div className="flex flex-col gap-nano">
            <Skeleton className="h-mini w-1/6" />
            <div className="overflow-hidden rounded-sm border-hairline border-ctx-layout-border">
              {[0, 1, 2, 3].map(i => (
                <div key={i}>
                  <div className="flex items-center gap-micro px-mini py-micro">
                    <Skeleton shape="circle" className="h-xs w-xs shrink-0" />
                    <Skeleton className="h-mini w-1/2" />
                  </div>
                  {i < 3 && <div className="h-px bg-ctx-layout-border" />}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Pagination skeleton */}
        <div className="flex justify-center gap-nano px-xs pb-xs">
          {[0, 1, 2, 3, 4].map(i => (
            <Skeleton key={i} className="h-xs w-xs rounded-sm" />
          ))}
        </div>
      </div>
    </div>
  );
}
